export default __webpack_public_path__ + "static/media/attensie-groepskorting.21798fad.svg";